module.exports = __webpack_public_path__ + "img/syria.ec939387.svg";